export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};

export const LIBRARY_NAME = "bob-core-components";

export default THEMES;
